import { createReducer } from 'typesafe-actions';
import { FullAppActions } from '@store/actions';
import { setFullAppFlow, setShowFullAppExitModal } from '@store/actions/fullApp.action';

export interface FullAppState {
    hasFullAppFlow: boolean;
    isShowFullAppExitModal: boolean;
}

export const initState: FullAppState = {
    hasFullAppFlow: false,
    isShowFullAppExitModal: false
};

export const fullAppReducer = createReducer<FullAppState, FullAppActions>(initState)
    .handleAction(setFullAppFlow, (state, action) => ({
        ...state,
        hasFullAppFlow: action.payload
    }))
    .handleAction(setShowFullAppExitModal, (state, action) => ({
        ...state,
        isShowFullAppExitModal: action.payload
    }));
